<template>
  <a href="javascript:void(0)">
    <i class="fa-solid fa-phone"></i>
  </a>

  <div class="custom-menu notification-dropdown p-0 overflow-hidden">
    <h3 class="title bg-primary-light dropdown-title">
      Call History
      <a class="link-underline font-primary">
        View all
        <i class="fs-6 fa-solid fa-arrow-up-right-from-square"></i>
      </a>
    </h3>
    <div class="vertical-scroll">
      <div class="list-group" id="call-history" v-for="call in callHistory">
        <div class="list-group-item" :class="getStatusBorder(call.status)">
          <p class="mb-1 f-w-700">
            {{ call.caller }}
            <small class="pull-right" v-text="getTimeAgo(call.time)" :title="call.time"></small>
          </p>

          <p class="mb-0 font-bold">
            <span class="pull-left btn-sm" :class="getStatusBadge(call.status)">{{ call.status }}</span>
            <a class="p-0 pull-right link-underline font-primary">
              Details
              <i class="fs-6 fa-solid fa-arrow-up-right-from-square"></i>
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, onUnmounted} from "vue";
import {format} from 'timeago.js';

const STATUS = {
  INITIATED: 'Initiated',
  RINGING: 'Ringing',
  IN_PROGRESS: 'In Progress',
  ANSWERED: 'Answered',
  COMPLETED: 'Completed',
  BUSY: 'Busy',
  NO_ANSWER: 'No Answer',
  FAILED: 'Failed',
  CANCELED: 'Canceled'
};

const callHistory = ref([]);
const pollingInterval = 30000; //30 seconds poll time
let pollingTimer;

// Function to fetch call history
const fetchCallHistory = async () => {
  try {
    const response = await fetch("/api/call/get-history-notifications");
    if (response.ok) {
      callHistory.value = await response.json();
    } else {
      console.error("Failed to fetch call history");
    }
  } catch (error) {
    console.error("Error fetching call history:", error);
  }
};

const startPolling = () => {
  pollingTimer = setInterval(fetchCallHistory, pollingInterval);
};

const stopPolling = () => {
  clearInterval(pollingTimer);
};

const getTimeAgo = (value) => {
  const date = new Date(value);
  if (isNaN(date)) {
    return "N/A";
  }
  return format(date);
};

const getStatusBadge = (value) => {
  let className = '';
  switch (value) {
    case STATUS.INITIATED:
      className = 'btn badge-light';
      break;

    case STATUS.RINGING:
    case STATUS.IN_PROGRESS:
      className = 'btn badge-info border-light-secondary text-secondary';
      break;

    case STATUS.ANSWERED:
      className = 'btn bg-primary border-light-primary text-primary';
      break;

    case STATUS.COMPLETED:
      className = 'btn bg-success border-light-success text-success';
      break;

    case STATUS.NO_ANSWER:
      className = 'btn bg-warning border-light-warning text-warning';
      break;

    case STATUS.FAILED:
    case STATUS.CANCELED:
    case STATUS.BUSY:
      className = 'btn bg-danger border-light-danger text-danger';
      break;
  }

  return className;
};

const getStatusBorder = (value) => {
  let className = '';
  switch (value) {
    case STATUS.INITIATED:
      className = 'border-left-light';
      break;

    case STATUS.RINGING:
    case STATUS.IN_PROGRESS:
      className = 'border-left-secondary';
      break;

    case STATUS.ANSWERED:
      className = 'border-left-primary';
      break;

    case STATUS.COMPLETED:
      className = 'border-left-success';
      break;

    case STATUS.NO_ANSWER:
      className = 'border-left-warning';
      break;

    case STATUS.FAILED:
    case STATUS.CANCELED:
    case STATUS.BUSY:
      className = 'border-left-danger';
      break;
  }

  return className;
};

// Lifecycle hooks
onMounted(() => {
  fetchCallHistory();
  startPolling();
});

onUnmounted(() => {
  stopPolling(); // Cleanup polling on component unmount
});

</script>